function Cta() {
  return (
    <section className="container-page py-16 md:py-20">
      <div className="relative overflow-hidden rounded-3xl bg-accent-500">
        <div className="absolute inset-0 bg-gradient-to-br from-accent-500 to-accent-700"></div>
        <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-accent-400/40 blur-2xl"></div>
        <div className="absolute -bottom-16 -left-10 h-48 w-48 rounded-full bg-secondary-300/30 blur-2xl"></div>

        <div className="relative z-10 flex flex-col items-center px-6 py-14 text-center md:py-16">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-50/20 text-3xl text-background-50">
            <i className="ri-emotion-happy-line"></i>
          </span>
          <h2 className="mt-5 font-heading text-3xl text-background-50 md:text-4xl">
            别让烦恼过夜，让丫头逗你开心
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-accent-50/90 md:text-base">
            大黄丫头漫画搞笑日常与幽默片段合集持续更新，轻松看一话不落。现在就去逛一逛，找到属于你今天的那一抹笑点吧。
          </p>
          <a
            href="#featured"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-8 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-8 py-3.5 text-sm font-bold text-accent-600 transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-accent-300"
          >
            <i className="ri-play-fill mr-2 text-lg"></i>
            马上轻松看笑点
          </a>
        </div>
      </div>
    </section>
  );
}

export default Cta;